// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__2voFn"};